import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function ResetPassword() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Passwort zurücksetzen</CardTitle>
          <p className="text-muted-foreground">Setzen Sie Ihr Passwort zurück</p>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground text-center">
            Passwort-Reset wird in der nächsten Phase implementiert.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}